<cs-content>
  <div class="intro-container">
    <div #cardHolder class="intro-carousel">
      @for (slide of slides; track slide.imageUrl; let i = $index) {
        <div class="intro-carousel__slide" [ngClass]="{current: i === currentSlideNum}">
          <div class="intro-carousel__image">
            @if (slide.imageUrl) {
              <img src="{{slide.imageUrl}}" />
            }
          </div>
          <div class="intro-carousel__text">
            <div class="intro-main-panel__title">{{ slide.title }}</div>
            <div class="intro-main-panel__paragraphs">
              @for (p of slide.text.split('\n'); track $index) {
                <div class="intro-main-panel__paragraph">{{ p }}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>


    <div class="intro-main-panel">
      <!-- landscape-only: text + actions live in the side panel so the
           right-side square carousel can be image-only, matching the
           desktop layout that pre-dates the in-slide-content restructure -->
      @for (slide of [slides[currentSlideNum]]; track $index) {
        <div class="intro-main-panel__text">
          <div class="intro-main-panel__title">{{ slide.title }}</div>
          <div class="intro-main-panel__paragraphs">
            @for (p of slide.text.split('\n'); track $index) {
              <div class="intro-main-panel__paragraph">{{ p }}</div>
            }
          </div>
        </div>
      }

      <!-- all three buttons are always rendered; inactive ones use
           `visibility: hidden` so the action area's height stays constant
           between slides -->
      <div class="intro-main-panel__actions">
        <cs-button
          tertiary
          [attr.medium]="hasClientSmallScreen() ? '' : null"
          [class.intro-main-panel__action--hidden]="currentSlideNum >= slides.length - 1"
          (click)="closeCarousel()">
          {{ LL.intro.skip() }}
        </cs-button>

        <cs-button
          id="prevButton"
          secondary
          [attr.medium]="hasClientSmallScreen() ? '' : null"
          [class.intro-main-panel__action--hidden]="currentSlideNum <= 0"
          (click)="prevSlide()">
          {{ LL.intro.back() }}
        </cs-button>

        <cs-button
          id="{{'nextButton' + currentSlideNum}}"
          primary
          [attr.medium]="hasClientSmallScreen() ? '' : null"
          (click)="nextSlide()">
          @if (currentSlideNum < slides.length - 1) {
            <span>{{ LL.intro.next() }}</span>
          }
          @if (currentSlideNum === slides.length - 1) {
            <span>{{ LL.intro.start() }}</span>
          }
        </cs-button>
      </div>

      <div class="intro-main-panel__dots">
        @for (s of slides; track s.imageUrl; let i = $index) {
          <div class="intro-main-panel__dot"
          [ngClass]="{active: i===currentSlideNum}"></div>
        }
      </div>
    </div>
  </div>
</cs-content>
